import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__top gold-bar" />
      <div className="footer__body">
        <div className="footer__inner">
          <div className="footer__brand">
            <h3>Giuseppe's</h3>
            <p className="footer__tagline">Ristorante Italiano</p>
            <p className="footer__address">
              49120 Gratiot Ave<br />
              Chesterfield, Michigan 48051
            </p>
            <a href="tel:5869484900" className="footer__phone">586-948-4900</a>
          </div>

          <div className="footer__nav">
            <h4>Navigate</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/menu">Menu</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer__hours">
            <h4>Hours</h4>
            <p>Call us for current hours</p>
            <a
              href="https://www.facebook.com/GiuseppesRestaurant"
              target="_blank"
              rel="noreferrer"
              className="footer__fb"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
              </svg>
              Facebook
            </a>
          </div>
        </div>
      </div>
      <div className="footer__bottom">
        <p>© {new Date().getFullYear()} Giuseppe's Restaurant · Chesterfield, MI</p>
      </div>
    </footer>
  );
}
